import { bevelPositions, frameTypes } from '../config'

export default {
  APP_TYPE: 'essilorsk',
  isAdvancePaymentSystemEnabled: false,
  isSendingOrdersViaSoap: true,
  colors: {
    primary: '#122639', 
  },

  isSummaryTooltipEnabled: true,
  isCanCreateOrdersForOthersEnabled: true,
  hasLogoutInHeader: true,
  isOrderCancellationEnabled: true,
  orderCancellationTime: 1,
  isBifocalVisualisationEnabled: false,
  showShapeGeometryCenterAtStep2: true,
  showFooterImpressum: false,
  showFooterGdprDoc: false,
  showFooterLegalDoc: false,
  showOrdersTableIdColumn: false,
  hideOrdersSourceSwitch: true, // hide order source switch on HP
  useNativeCookieConsent: true,
  defaultCopyReferenceOnDuplication: false,
  safetyMarginStock: 1.5, // value added to radius
  safetyMarginManufacturer: 1.5, // value added to radius
  isMiLensEnabled: false,
  orderSanitizeStringsVariant: 'FULL', // FULL or SOFTER
  areFtpDeliveryNotesEnabled: false,
  hostConf: {
    isGoToWowEnabled: false,
    wowUrl: '',
    htmlTitle: 'Smile Online',
    logo: {
      publicPath: '/public/images/smile-online.png',
    },
    logoSquared: {
      publicPath: '/public/images/smile-online.png',
    },
    navbarLogoMaxHeight: 4.5,
    favicon: {
      publicPath: '/public/favicon-smile-online.png',
    },
    areDeliveryNotesEnabled: false,
    deliveryNotesVersion: 'default',
    isGetOrderPriceEnabled: false,
  },
  uniqueTranslationKeyPrefix: 'esk;',
  versionPrefix: 'e',
  isGoToWowEnabled: true,
  languages: ['sk', 'cs', 'en'],
  isCustomDiameterEnabled: true,
  isEllipticalDiameterEnabled: true,
  isInternalNoteEnabled: true,
  // considerDesignShift: false, // in lens diameter calculation (getFinalRadiiByShapeAndLenses) - not used anymore
  isLensBaseEnabled: true, // base curve field in refractions section
  // select base curve field after diameter selection with options from catalog
  isBaseCurveSelectEnabled: false,
  isSphAndCylInHundredthsEnabled: false,
  sphAndCylInHundredthsGroups: [],
  isWithShapeOnlyLensesEnabled: false,
  showCalcSurfacePoints: true,
  isExpressOrderEnabled: true,
  isExpress48Enabled: false,
  isCenterThicknessEnabled: true,
  step2DefaultBevelPositionForEdgingOrder: undefined,
  step2AutoPolish: true, // in step 2, automatically set polish field based on frame type
  // let user decide wether spectacles (only) lenses should be polished, customizable via group
  isSpectaclesPolishEnabled: false,
  isPinBevelEnabled: false,
  areFramesEnabled: false,
  isUvSelectionEnabled: true,
  isDecentrationEnabled: true,
  isSoapEnabled: true,
  isSortLensOptionsByNameEnabled: true,
  isMandatoryColorPreselectEnabled: true,
  soapDevUrl: 'https://soap.essilorsk.azuredev.virtii.com',
  soapProdUrl: 'https://soap.smileonline.sk',

  isFrameCurveStep2Visible: true,
  
  // same as right will be disabled
  areBothLensesAlwaysSame: true,

  arePromotionsEnabled: false,

  // enables fetching order prices from LW soap server
  // isGetOrderPriceEnabled: true must be added to hostConf
  isGetPricesFromLWSoapEnabled: false,

  lensFocusTypes: {
    'Single vision': {
      S: 'Single vision conv',
      X: 'Single vision individual',
    },
    A: 'Multifocal',
    Progressive: {
      C: 'Progressive conv',
      F: 'Progressive freeform',
      I: 'Progressive individual',
      U: 'Progressive Duo',
    },
    D: 'Office / Degressive',
    B: 'Bifocal',
  },

  // deprecated, used as fallback
  // set it in keystone frameBrand
  suppliersMap: {
    OME: 'OME',
    '4EY': '4 Eyes',
  },

  individualMenus: {
    // true = mandatory field
    // false = hidden field
    // order matters! Higher wins if two different lenses selected
    FFUIOT: {
      bvd: true,
      panto: true,
      frameBowAngle: true,
    },
    SPT001: {
      bvd: true,
      panto: true,
      frameBowAngle: true,
    },
    FFUINS: {
      bvd: true,
      panto: true,
      frameBowAngle: true,
    },
    FFUSP1: {
      bvd: false,
    },
    FFUSP2: {
      bvd: false,
    },
    FFUSLM: {
      bvd: false,
      panto: false,
      frameBowAngle: false,
    },
    FFUCRB: {
      bvd: {
        isRequired: false,
        min: 6,
        max: 30,
      },
      panto: {
        isRequired: false,
        min: 0,
        max: 30,
      },
      frameBowAngle: {
        isRequired: false,
        min: 0,
        max: 35,
      },
    },
    FFUSP3: {},
  },
  getBevelPositions: () => [
    bevelPositions.AUTO,
    bevelPositions.FRONT,
    bevelPositions.PERCENT,
    bevelPositions.HALF,
    bevelPositions.SMART,
  ],
  // should be function returning array, otherwise default - all; check jzo for reference
  getFrameTypes: () => [
    frameTypes.METAL,
    frameTypes.PLASTIC,
    frameTypes.SPECIAL,
    frameTypes.NYLOR,
    frameTypes.DRILLED,
    frameTypes.GROOVEDDRILLED,
  ],
}
